// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jo1-V","title":"styles_title__1gAVp"};